import * as React from "react";
const SvgHashtag = props => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 4L7 20M17 4L14 20M5 8H20M4 16H19" stroke="currentColor" strokeWidth={2} strokeLinecap="round" /></svg>;
export default SvgHashtag;